import React from "react";
import Title from "../layouts/Title";
import Card from "./Card";
import { featuresData } from "../../data/data";
import { motion } from 'framer-motion';
import { useNavigate } from "react-router-dom";

const Features = ({ showAll = false }) => {
  const navigate = useNavigate();
  const displayData = showAll ? featuresData : featuresData.slice(0, 6);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.08 },
    },
  };

  return (
    <section id="features" className="w-full py-8">
      <div className="flex justify-center items-center text-center mb-8">
        <Title title="What I Do" des="Services" />
      </div>
      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-50px" }}
        className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4"
      >
        {displayData.map((item) => (
          <Card item={item} key={item.id} />
        ))}
      </motion.div>

      {!showAll && (
        <div
          className="flex justify-center items-center mt-8 cursor-pointer group"
          onClick={() => navigate("/services")}
        >
          <span className="text-sm font-titleFont text-gray-400 group-hover:text-cyan-400 transition-all duration-300 mr-2">
            View All Services
          </span>
          <span className="text-cyan-400 group-hover:translate-x-2 transition-transform duration-300">
            →
          </span>
        </div>
      )}
    </section>
  );
};

export default Features;
